/**
 * No coach names or avatars are shown until there are real, verified buyers.
 * Badge colours stay here for the Testimonials component.
 */
export const avatarColors = ['bg-coral', 'bg-indigo', 'bg-teal', 'bg-amber', 'bg-coral', 'bg-indigo']
